export default {
    apiUrl: 'DOCKER_API_URL',
    appVersion: '2'
}